import EnedisCarto from "./enedis-carto.js";
import RteCarto from "./rte-carto.js";

export class EnedisHTLines extends EnedisCarto {

    constructor() {
        super(['reseau-hta', 'reseau-souterrain-hta']);
    }

    overrideStyle(feature) {
        const opacity = super.getOpacity();
        this.getMap().data.overrideStyle(feature, {
            strokeColor: this.color,
            strokeOpacity: opacity
        })
    }

    get color() {
        return '#FF0000'
    }
}

export class EnedisBTLines extends EnedisCarto {

    constructor() {
        super(['reseau-bt', 'reseau-souterrain-bt']);
    }

    overrideStyle(feature) {
        const opacity = this.getOpacity();
        this.getMap().data.overrideStyle(feature, {
            strokeColor: this.color,
            strokeOpacity: opacity
        })
    }

    get color() {
        return '#009EFF';
    }

}

export class EnedisDeliveryPosts extends EnedisCarto {

    constructor() {
        super(['poste-electrique']);
    }

    overrideStyle(feature) {
        this.getMap().data.overrideStyle(feature, {
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                fillColor: this.color,
                fillOpacity: this.getOpacity(),
                strokeWeight: 0,
                strokeColor: this.color,
                rotation: 0,
                scale: 12,
              },
        });
    }

    get color() {
        return '#FF00E8';
    }
}

export class EnedisSourcePosts extends EnedisCarto {

    constructor() {
        super(['poste-source']);
    }

    overrideStyle(feature) {
        this.getMap().data.overrideStyle(feature, {
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                fillColor: this.color,
                fillOpacity: this.getOpacity(),
                strokeWeight: 0,
                strokeColor: this.color,
                rotation: 0,
                scale: 12,
              },
        });
    }

    get color() {
        return '#FF7C00';
    }
}

export class RteLines extends RteCarto {
    constructor() {
        super(['lignes-aeriennes-rte-nv', 'lignes-souterraines-rte-nv']);
    }

    overrideStyle(feature) {
        const opacity = super.getOpacity();
        this.getMap().data.overrideStyle(feature, {
            strokeColor: this.color,
            strokeOpacity: opacity
        })
    }

    get geoField() {
        return "geo_shape"
    }

    get color() {
        return '#FFEC00'
    }
}

export class RtePylones extends RteCarto {

    constructor() {
        super(['pylones-rte']);
    }

    overrideStyle(feature) {
        this.getMap().data.overrideStyle(feature, {
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                fillColor: this.color,
                fillOpacity: this.getOpacity(),
                strokeWeight: 0,
                strokeColor: this.color,
                rotation: 0,
                scale: 12,
              },
        });
    }

    get color() {
        return '#FEFFFF';
    }

    get geoField() {
        return "geo_point_pylone";
    }
}

export class RtePostes extends RteCarto {

    constructor() {
        super(['postes-electriques-rte']);
    }

    overrideStyle(feature) {
        this.getMap().data.overrideStyle(feature, {
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                fillColor: this.color,
                fillOpacity: this.getOpacity(),
                strokeWeight: 0,
                strokeColor: this.color,
                rotation: 0,
                scale: 12,
              },
        });
    }

    get geoField() {
        return "geo_point_poste";
    }

    get color() {
        return '#FF7C00';
    }
}
